import { render } from "./SlideMenu.vue?vue&type=template&id=70859927"
import script from "./SlideMenu.vue?vue&type=script&lang=js"
export * from "./SlideMenu.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__